import * as tslib_1 from "tslib";
import { Component, Vue, Watch } from 'vue-property-decorator';
import { Layout } from '@h3/antd-vue';
import { namespace } from 'vuex-class';
// import * as FlowCenter from '@cloudpivot/flow-center';
// import * as Application from '@cloudpivot/application';
// import AppsMenu from './menu/apps-menu.vue';
import common from '@cloudpivot/common';
import WorkflowCenterMenu from '@cloudpivot/flow-center/src/components/pc/menu/workflow-center-menu.vue';
import AppsMenu from '@cloudpivot/application/src/components/pc/apps-menu.vue';
const WorkflowCenterModule = namespace('WorkflowCenter/WorkflowCenter');
let Aside = class Aside extends Vue {
    constructor() {
        super(...arguments);
        // 侧边栏可拖拽初始宽度
        this.dragWidth = 200;
        this.startX = 200;
        // false 展开 true收起
        this.isShow = false;
        this.curMenu = 'WorkflowCenterMenu';
        this.menuTitle = '流程中心';
        this.menuTitleI18n = {};
        // @Watch('dragWidth')
    }
    // 判断当前是否是中文版本
    get isChinese() {
        return this.$i18n.locale === 'zh';
    }
    mounted() {
        this.switchMenu();
        // 拖拽功能
        this.$nextTick(() => {
            const dragLine = document.querySelector('#jDragLine');
            let that = this;
            let maxClientWidth;
            let minWidth;
            let maxWidth;
            dragLine.addEventListener('mousedown', (e) => {
                maxClientWidth = document.body.clientWidth / 3;
                minWidth = that.dragWidth - 8;
                maxWidth = that.dragWidth + 8;
                document.body.setAttribute('unselectable', 'on');
                document.body.setAttribute('onselectstart', 'return false;');
                if (e.clientX >= minWidth && e.clientX <= maxWidth) {
                    document.onmousemove = function (ev) {
                        // 收缩的时候不允许拖拽
                        if (that.isShow)
                            return;
                        that.dragWidth = ev.clientX;
                        if (ev.clientX > maxClientWidth) {
                            that.dragWidth = maxClientWidth;
                        }
                        else if (ev.clientX < that.startX) {
                            that.dragWidth = that.startX;
                        }
                        common.utils.Bus.$emit('resize');
                    };
                    document.onmouseup = function () {
                        document.body.removeAttribute('unselectable');
                        document.body.removeAttribute('onselectstart');
                        document.onmousemove = null;
                        document.onmouseup = null;
                    };
                }
            }, false);
        });
        const curDom = this.$refs.slider;
        curDom.$el.addEventListener('transitionend', this.transitionendEvent, false);
    }
    transitionendEvent(e) {
        if (e.propertyName === 'width') {
            common.utils.Bus.$emit('resize');
        }
    }
    beforeDestroy() {
        const curDom = this.$refs.slider;
        curDom.$el.removeEventListener('transitionend', this.transitionendEvent, false);
    }
    // 切换菜单
    switchMenu() {
        if (!this.$route)
            return;
        const { fullPath } = this.$route;
        const isWorkflowCenterRoute = fullPath.includes('workflow-center');
        const isApplicationRoute = fullPath.includes('application');
        if (isWorkflowCenterRoute) {
            this.curMenu = 'WorkflowCenterMenu';
        }
        else if (isApplicationRoute) {
            this.curMenu = 'AppsMenu';
            this.menuTitle = this.asideTitle;
            this.menuTitleI18n = this.asideTitleI18n;
        }
    }
    hideMenu() {
        this.isShow = !this.isShow;
        if (this.isShow) {
            this.dragWidth = 52;
            this.startX = 52;
        }
        else {
            this.dragWidth = 200;
            this.startX = 200;
        }
    }
    onRouterChange() {
        this.switchMenu();
    }
    onAsideTitleChange(v) {
        if (v) {
            this.menuTitle = v;
        }
    }
    onAsideTitleI18nChange(v) {
        if (v) {
            this.menuTitleI18n = v;
        }
    }
};
tslib_1.__decorate([
    WorkflowCenterModule.State('asideTitle')
], Aside.prototype, "asideTitle", void 0);
tslib_1.__decorate([
    WorkflowCenterModule.State('asideTitleI18n')
], Aside.prototype, "asideTitleI18n", void 0);
tslib_1.__decorate([
    Watch('$route')
], Aside.prototype, "onRouterChange", null);
tslib_1.__decorate([
    Watch('asideTitle')
], Aside.prototype, "onAsideTitleChange", null);
tslib_1.__decorate([
    Watch('asideTitleI18n')
], Aside.prototype, "onAsideTitleI18nChange", null);
Aside = tslib_1.__decorate([
    Component({
        name: 'Aside',
        components: {
            ALayoutSider: Layout.Sider,
            // WorkflowCenterMenu: FlowCenter.components.pc.WorkflowCenterMenu,
            // AppsMenu: Application.components.pc.AppsMenu
            WorkflowCenterMenu,
            AppsMenu
        }
    })
], Aside);
export default Aside;
